export default {
    props: [],
    template: /*html*/`
    <div class="ring-1 ring-black/10 rounded-2xl bg-light flex flex-wrap justify-center gap-8 p-10">
        <slot></slot>
    </div>
    `
}